var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// eslint-disable-next-line no-unused-vars
import React, { useContext } from 'react';
import { injectTestId } from '@cvent/nucleus-test-automation';
import { ThemeContext } from '@cvent/carina-theme-provider';
import { getStyle } from './barGetStyle';
import { keyframes } from '@emotion/react';
export var ProgressBar = function (_a) {
    var progressBarLabelledBy = _a.progressBarLabelledBy, value = _a.value, text = _a.text, size = _a.size, colors = _a.colors, testID = _a.testID, _b = _a.total, total = _b === void 0 ? 100 : _b, rest = __rest(_a, ["progressBarLabelledBy", "value", "text", "size", "colors", "testID", "total"]);
    var theme = useContext(ThemeContext);
    var style = useStyle(theme, size);
    var barStyle = function () {
        if (typeof value === 'undefined') {
            return __assign(__assign({}, style.barProgressBar), style.indeterminate);
        }
        return __assign(__assign({}, style.barProgressBar), style.determinate(Math.ceil((value / total) * 100), colors));
    };
    return (_jsxs("div", __assign({ css: style.outerContainer }, injectTestId(testID), { role: "progressbar", "aria-valuenow": value ? Math.ceil((value / total) * 100) : undefined, "aria-live": typeof value !== 'undefined' ? 'assertive' : undefined, "aria-labelledby": progressBarLabelledBy }, { children: [text && text, _jsx("div", __assign({}, rest, { css: style.barContainer }, { children: _jsx("div", { css: barStyle() }, void 0) }), void 0)] }), void 0));
};
function useStyle(theme, size) {
    var _a = React.useMemo(function () { return getStyle({ theme: theme }); }, [theme]), barContainer = _a.barContainer, barProgressBar = _a.barProgressBar, indeterminate = _a.indeterminate, outer = _a.outer;
    return {
        outerContainer: __assign(__assign({}, (size && barContainer[size])), outer),
        barContainer: __assign(__assign({}, barContainer.base), (size && barContainer[size])),
        barProgressBar: barProgressBar.base,
        indeterminate: indeterminate.base,
        determinate: function (value, colors) {
            var colorTransitionAnimation;
            if (colors && colors.length > 1) {
                var frames_1 = '';
                var stepSize = 100 / (colors.length - 1);
                for (var i = 0; i < colors.length; i++) {
                    frames_1 += "\n            " + stepSize * i + "% {\n              background: " + colors[i] + ";\n            }\n          ";
                }
                colorTransitionAnimation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", ""], ["", ""])), frames_1);
            }
            return __assign(__assign({}, (typeof colorTransitionAnimation !== 'undefined'
                ? {
                    // This animation doesn't progress on its own but instead has its position set by the bar's value. So if
                    // the value is 53% this animation will show as if it was at 53 seconds. This means that the total length
                    // of the animation must be the max value in seconds (100s) plus 1s, so 101s. The +1 is because when
                    // the animation reaches 100s it will be finished and won't show the final color, adding 1 fixes this.
                    animation: "101s linear -" + value + "s paused " + colorTransitionAnimation
                }
                : {
                    backgroundImage: "linear-gradient( to right, " + theme.backgroundColor.tertiary.fill.base + ",  " + theme.backgroundColor.brand.fill.focus + ",   " + theme.backgroundColor.accent.fill.base + ")"
                })), { clipPath: "inset( 0%  " + (100 - value) + "%  0% 0% round  6px )", 
                // selector for edge and ie. Edge does not follow the -ms- vendor prefix,
                // but it also does not support clip path features, so in order to support edge, we need to lump it in with
                // the other microsoft browser. This is probably one of the least messy ways of going about it that I
                // could think up, but if there is another way that isn't a hack, please let me know.
                '_:-ms-lang(x), &': {
                    width: value + "%"
                }, MsClipPath: "circle( " + (100 - value) + "%  at 0% 50%)" });
        }
    };
}
var templateObject_1;
